"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBinary = isBinary;
function isBinary(content) {
    return content.includes(0);
}
//# sourceMappingURL=binary.js.map